/** @deprecated use the component in the `@owl-nest/services` module */
export { Callout } from '@owl-nest/services/src/message/components/Callout'
